<template>
  <div class="submitted-deals">
     <breadcrumbs :breadcrumbsData="breadcrumbsData" />
     <artmisads-segmented-tabs v-model="activeTab" :items=" [
        { key: '0', label: 'AI折扣管理后台', disabled: false  },
        // { key: '1', label: 'Records', disabled: false  },
        { key: '2', label: 'BlackList', disabled: false },  // 禁用状态
        { key: '3', label: '重点商家名单', disabled: false },  // 禁用状态
      ]" />
    <aiList v-if="activeTab=='0'"/>
    <records v-if="activeTab=='1'"/>
    <blacklist v-if="activeTab=='2'"/>
    <whiteList v-if="activeTab=='3'"/>
  </div>

</template>
<script setup>
import breadcrumbs from '../breadcrumbs.vue'
import records from './components/records.vue'
import blacklist from './components/blacklist.vue'
import whiteList from './components/whiteList.vue'
import aiList from './components/aiList.vue'
import { ref, onMounted } from 'vue'
const activeTab=ref('0')
const breadcrumbsData = ref({
  title: 'DealSD',
  des: '',
  links: [
    {
      name: 'Home',
      path: '/operator/users',
    },
    {
      name: 'Operation',
      path: '/operator/operation/manualPayments',
    },
    {
      name: 'DealSD',
      path: '/operator/operation/submittedDeals',
    },
  ],
})
</script>
<style scoped lang="less">
  .content{
    width: 180px;
display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制行数为3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  }
.submitted-deals {
  padding: 16px;

  width: 100%;
}
.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

}
.filterBox {
  padding: 15px 16px;
  margin: 16px 0;
  flex-wrap: wrap;
  border-radius: 8px;
  background: #fff;
}
.btn-box {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}
.filter {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  .filter-item {
    display: flex;
    gap: 10px;
    align-items: center;
    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      opacity: 0.9;
    }
  }
}
</style>
